import React from "react";
import { Card, CardContent } from "./ui/card";
import { ResultCard } from "./ui/result-card";
import { NamedIcon } from "~/components/ui/named-icon";
import type { CoachingResultsSelect } from "../../drizzle/schema";

export const CoachResultsCard = ({
  results,
}: {
  results: CoachingResultsSelect[];
}) => {
  if (!results.length) {
    return null;
  }

  return (
    <Card>
      <CardContent className="flex flex-col gap-8">
        <div className="grid grid-cols-3 items-stretch justify-center gap-6">
          {results.map((result) => {
            return (
              <ResultCard
                key={result.id}
                icon={
                  <NamedIcon
                    name={result.icon}
                    className="text-6xl text-purple-700"
                  />
                }
                title={result.title}
                description={result.description}
              />
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
